import { useEffect } from 'react'
import PropTypes from '~/lib/propTypes'
import styled from '@emotion/styled'
import { DialogBody, space } from '@ticketswap/solar'
import EmailSent from '~/components/EmailSentIllustration'

const Container = styled.div`
  text-align: center;
`

const Illustration = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-block-end: ${space[32]};
`

const PositiveConfirm = ({ t, hide }) => {
  useEffect(() => {
    const timeout = setTimeout(hide, 4000)

    return () => clearTimeout(timeout)
  }, [hide])

  return (
    <DialogBody>
      <Illustration>
        <EmailSent />
      </Illustration>
      <Container>
        <p>{t('common:feedbackDialog.confirm.text.positive')}</p>
      </Container>
    </DialogBody>
  )
}

PositiveConfirm.propTypes = {
  t: PropTypes.func.isRequired,
  hide: PropTypes.func.isRequired,
}

export default PositiveConfirm
